"use client";

import Image from "next/image";
import AnimatedContent from "../AnimatedContent";
import { useTranslation } from "react-i18next";
import SectionContainer from "@/common/SectionContainer";

interface FeatureItem {
  title: string;
  description: string;
}

const ColortoLifeSection = () => {
  const { t } = useTranslation();
  const features = t("COLORTOLIFE_SECTION_FEATURES", {
    returnObjects: true,
  }) as FeatureItem[];

  return (
    <SectionContainer
      id="colortolife-section"
      className="section-shell bg-white text-gray-900"
    >
      <AnimatedContent className="section-inner grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
        <div className="relative w-full max-w-[600px] aspect-750/1061 rounded-md overflow-hidden shadow-xl mx-auto lg:mx-0">
          <Image
            src="https://zipshow-static-web.s3.ap-northeast-2.amazonaws.com/homepage/color-to-life-biz/color_to_life_background.png"
            alt={t("COLORTOLIFE_SECTION_IMAGE_ALT")}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            className="object-cover"
          />
        </div>

        <div className="flex flex-col items-center md:items-start justify-center text-center lg:text-left">
          <div className="bg-gradient-to-r from-[#5BBF4D]/80 to-[#207AE8]/80 text-white font-semibold text-[clamp(1rem,1.8vw,1.25rem)] py-1 px-4 rounded-xl w-fit mx-auto lg:mx-0">
            {t("COLORTOLIFE_SECTION_BADGE")}
          </div>

          <div className="flex items-baseline py-4 gap-2">
            <h2 className="section-title">{t("COLORTOLIFE_SECTION_TITLE")}</h2>
            <p className="metric-label text-gray-800 font-medium">
              {t("COLORTOLIFE_SECTION_SUB_TITLE")}
            </p>
          </div>

          <p className="text text-gray-700 max-w-[640px] mx-auto lg:mx-0 whitespace-pre-wrap">
            {t("COLORTOLIFE_SECTION_DESCRIPTION")}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 py-6 md:py-12">
            {features.map((f) => (
              <div
                key={f.title}
                className="flex flex-col gap-2 items-center text-center rounded-2xl py-6 px-5 shadow-md hover:scale-[1.03] transition-transform"
              >
                <h4 className="font-semibold text-[clamp(1rem,1.6vw,1.15rem)] mb-2">
                  {f.title}
                </h4>
                <p className="text-[clamp(0.75rem,1.6vw,1rem)] mb-2 text-gray-700">
                  {f.description}
                </p>
              </div>
            ))}
          </div>

          <p className="caption text-gray-600">
            {t("COLORTOLIFE_SECTION_CAPTION")}
          </p>
        </div>
      </AnimatedContent>
    </SectionContainer>
  );
};

export default ColortoLifeSection;
